/* Variantenauswahl + Galerie auf der Produktseite. */
(function () {
  'use strict';
  function money(cents, format) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-tn-stage]');
    if (!stage) return;
    root.querySelectorAll('[data-tn-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-tn-thumb');
        root.querySelectorAll('[data-tn-thumb]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        stage.querySelectorAll('img').forEach(function (img) { img.classList.toggle('is-on', img.getAttribute('data-tn-slide') === i); });
        var name = stage.querySelector('[data-tn-viewname]');
        if (name) name.textContent = btn.getAttribute('data-tn-name') || '';
      });
    });
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-tn-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-tn-variant-id]');
    var priceEl = root.querySelector('[data-tn-price]');
    var wasEl = root.querySelector('[data-tn-was]');
    var btn = root.querySelector('[data-tn-submit]');
    var optCount = parseInt(root.getAttribute('data-tn-optcount') || '1', 10);

    function selected() {
      var out = [];
      for (var i = 1; i <= optCount; i++) {
        var on = root.querySelector('[data-tn-opt="' + i + '"].is-on');
        out.push(on ? on.getAttribute('data-tn-value') : null);
      }
      return out;
    }
    function find(values) {
      return variants.filter(function (v) {
        return values.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function markAvailability(values) {
      root.querySelectorAll('[data-tn-opt]').forEach(function (b) {
        var idx = parseInt(b.getAttribute('data-tn-opt'), 10) - 1;
        var probe = values.slice();
        probe[idx] = b.getAttribute('data-tn-value');
        var v = find(probe);
        b.classList.toggle('is-off', !v || !v.available);
      });
    }
    function apply(userPick) {
      var values = selected();
      var v = find(values);
      markAvailability(values);
      if (!v) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        wasEl.hidden = !sale;
        if (sale) wasEl.textContent = money(v.compare_at_price);
        if (priceEl) priceEl.classList.toggle('tn-price--sale', !!sale);
      }
      if (btn) {
        if (v.available) { btn.removeAttribute('aria-disabled'); btn.textContent = 'In den Warenkorb'; }
        else { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Ausverkauft'; }
      }
      if (userPick && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-tn-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var group = b.getAttribute('data-tn-opt');
        root.querySelectorAll('[data-tn-opt="' + group + '"]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        apply(true);
      });
    });
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-tn-product]').forEach(function (root) {
      initGallery(root);
      initVariants(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
